module.exports = __webpack_public_path__ + "img/12.8fca8695.png";